module.exports = __webpack_public_path__ + "e145c25e7611072d1d1991eb12d61bda.ttf";